module.exports = __webpack_public_path__ + "media/solemn.faeb61d7.mp3";